<script lang="ts" setup>
import AttributeTable from "@/data-views/tables/attribute/AttributeTable.vue";
definePage({
  meta: {
    action: "read",
    subject: "Attribute",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <AttributeTable />
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
